import { render } from "./Quizz.vue?vue&type=template&id=0dfdd25e"
import script from "./Quizz.vue?vue&type=script&lang=js"
export * from "./Quizz.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__